import React, { useContext } from 'react';
import ReactDOM from 'react-dom';

//component
import WorkspaceUsersScreen from  '@/components/page/OrgSettings/Workspaces/UsersTab/WorkspaceUsersScreen';

//context
import { OrgSettingsContext } from '@/context/OrgSettings';



const UsersPortal = () => {    
    const targetContainer = document.getElementById('react-workspace-users-container');
    const { setAppId, setOrgId } = useContext(OrgSettingsContext);

    // Dont load if container doesnt exist
    if (!targetContainer){
        return null;
    } else {
        setAppId(targetContainer.getAttribute('data-workspace-id'));
        setOrgId(targetContainer.getAttribute('data-org-id'))
    }

    return ReactDOM.createPortal(
      <WorkspaceUsersScreen />, targetContainer
    );
}


export default UsersPortal;